import React, { useState } from 'react';
import mobileChat from '~/assets/mobile-chat.svg';
import { AppStoreUrls } from '~/types';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { isAndroid, isIOS } from '~/utils/platform';
import { FaApple, FaAndroid } from 'react-icons/fa';

export function RegistrationSuccess({
  title,
  text,
  url,
  appStoreUrls,
}: {
  title: string;
  text: string;
  url: string;
  appStoreUrls: AppStoreUrls;
}) {
  const [showCopySuccess, setShowCopySuccess] = useState(false);

  const canShare = !!navigator.share;
  const canCopy = !!navigator.clipboard;

  const showAppleUrl = appStoreUrls.apple && (isIOS() || !isAndroid());
  const showAndroidUrl = appStoreUrls.android && (isAndroid() || !isIOS());

  const handleShare = () => {
    if (canShare) {
      navigator
        .share({
          title,
          text,
          url,
        })
        .catch(error => {
          console.error('Error sharing', error);
        });
    } else if (canCopy) {
      const fullUrl = window.location.origin + url;

      navigator.clipboard
        .writeText(fullUrl)
        .then(() => {
          setShowCopySuccess(true);
        })
        .catch(error => {
          console.error('Error sharing', error);
        });
    }
  };

  const linkClasses =
    'md:flex-0 mt-4 w-full flex items-center justify-center p-4 rounded-lg text-base border-2 font-semibold border-blackForReal text-blackForReal relative';

  return (
    <div className={'mt-4 mb-6'}>
      <div className={'mb-4 bg-gray-100 rounded-2xl p-4 flex items-center '}>
        <img src={mobileChat} alt={'Mobile chat'} className={'mr-2'} />

        <div>
          <div className={'font-bold text-lg'}>You&apos;re all set!</div>
          <div className={'text-gray-700'}>See you at the live event</div>
        </div>
      </div>

      {(canShare || canCopy) && (
        <button
          className={cn(
            'mt-6 md:flex-0 mt-4 w-full flex items-center justify-center p-4 rounded-lg text-base text-white bg-blackForReal font-semibold',
          )}
          style={{ height: 48 }}
          onClick={handleShare}
        >
          {showCopySuccess ? 'Link Copied!' : 'Share With Friends'}
        </button>
      )}

      <Link to={'/'} className={linkClasses} style={{ height: 48 }}>
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="bags-shopping"
          className="svg-inline--fa fa-bags-shopping absolute"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          style={{ height: 24, width: 24, left: 24 }}
        >
          <path
            fill="currentColor"
            d="M448 224V192c0-17.6-14.4-32-32-32l-96 0V99.61c0-46.43-31.37-89-76.96-97.77C181.7-9.965 128 36.77 128 96v64L32 160C14.4 160 0 174.4 0 192v256c0 17.6 14.4 32 32 32h128V272C160 245.6 181.6 224 208 224H448zM176 96c0-26.5 21.5-48 48-48S272 69.5 272 96v64h-96V96zM544 256H224C206.4 256 192 270.4 192 288v192c0 17.62 14.38 32 32 32h320c17.62 0 32-14.38 32-32V288C576 270.4 561.6 256 544 256zM480 351.1c0 27.62-12 53.99-32.75 72.1c-20.88 18.25-48.5 26.62-75.88 23.12C323 440.1 288 397.5 288 348.6V336c0-8.836 7.164-16 16-16c8.838 0 16 7.164 16 16v13.12c0 33.49 24.38 63.36 57.63 66.61c18 1.75 35.88-4.123 49.25-16.37C440.4 387.2 448 370.1 448 351.1v-15.1C448 327.2 455.2 320 464 320c8.838 0 16 7.163 16 15.1V351.1z"
          />
        </svg>
        Shop The Boutique
      </Link>

      {showAppleUrl && (
        <a
          href={appStoreUrls.apple}
          target={'_blank'}
          rel="noreferrer"
          className={linkClasses}
          style={{ height: 48 }}
        >
          <FaApple
            className="svg-inline--fa fa-apple absolute"
            style={{ height: 24, width: 24, left: 24 }}
          />
          Download Apple App
        </a>
      )}

      {showAndroidUrl && (
        <a
          href={appStoreUrls.android}
          target={'_blank'}
          rel="noreferrer"
          className={linkClasses}
          style={{ height: 48 }}
        >
          <FaAndroid
            className="svg-inline--fa fa-android absolute"
            style={{ height: 24, width: 24, left: 24 }}
          />
          Download Android App
        </a>
      )}
    </div>
  );
}
